import React from "react";
import Page from "./page";
import firebase from 'firebase/app';
import 'firebase/firestore';
import UserService from "../services/user_service";
import swal from "sweetalert";

class ListUsers extends React.Component {
    state: { isLoading: boolean, users: firebase.firestore.QueryDocumentSnapshot[], tempUsers: firebase.firestore.QueryDocumentSnapshot[] } = {
        isLoading: true,
        users: null,
        tempUsers: null
    }

    getRole(role: string): string {
        switch (role) {
            case "USER":
                return "Usuario"
            case "DRIVER":
                return "Conductor";
            case "DELIVERY":
                return "Delivery";
            default: return "Usuario"; 
        }
    }

    componentDidMount() {
        new UserService().getUsers().then(response => {
            
            this.setState({
                users: response.docs,
                tempUsers: response.docs,
                isLoading: false
            });
        })
    }

    renderUsers(): JSX.Element {
        const users = this.state.tempUsers;
        const cutLength = (text: string) => {
            
            if (text.length >= 25) {
                return text.slice(0, 25) + " ...";
            }

            return text;
        }

        return (
            <tbody>
                {
                    users.map<JSX.Element>(element => {
                        const user = element.data();

                        return (
                            <tr>
                                <th>
                                    <img src={user.photoUrl} alt="user profile" style={{
                                        "height": "3vh",
                                        width: "3vh",
                                        "borderRadius": "50%"
                                    }} />
                                </th>
                                <th>{user.fullName}</th>
                                <th style={{ cursor: "pointer" }} onClick={async () => {
                                    await window.navigator.clipboard.writeText(user.email);
                                    swal("El correo: " + user.email + " Fue copiado correctamente.");
                                }}>
                                    <i className="fas fa-copy"></i>

                                    <small style={{ marginLeft: 5}}>
                                    {cutLength(user.email || 'Sin correo')}
                                    </small>
                                </th>
                                <th>{user.phone}</th>
                                <th>{this.getRole(user.role)}</th>
                            </tr>
                        );
                    })
                }
            </tbody>
        );
    }

    filter(filter: string) {
        var response = [];
        const { value } = document.querySelector("#search-bar-list") as HTMLInputElement;

        for (const element of this.state.users) {
            const doc = element.data();
            const rol = doc.role || "USER";


            if (filter === "SEARCHBAR") {
                if (String(doc.fullName).includes(value.toLowerCase()) || String(doc.email).includes(value.toLowerCase())) {
                    response.push(element);
                }
            }else if (filter === "Todos") {
                response.push(element);
            } else if (filter === "Usuarios" && rol === "USER") {
                response.push(element);
            } else if (filter === "Drivers" && rol === "DRIVER") {
                response.push(element);
            } else if (filter === "Delivery" && rol === "DELIVERY") {
                response.push(element);
            }
        }

        this.setState({
            tempUsers: response,
        })
    }

    render() {
        if (this.state.isLoading) {
            return (
                <progress className="progress is-large is-info" max="100" style={{
                    width: "60%",
                    margin: "auto"
                }} />
            );
        }

        return (
            <Page>
                <div style={{ padding: 15 }}>
                    <div className="container-options" style={{
                        display: "flex",
                        justifyContent: "space-between"
                    }}>
                        <div className="buttons">
                            <button className="button is-warning" onClick={() => this.filter("Todos")}>
                                Todos
                            </button>
                            <button className="button is-success" onClick={() => this.filter("Usuarios")}>
                                Usuarios
                            </button>
                            <button className="button is-success" onClick={() => this.filter("Drivers")}>
                                Drivers
                            </button>
                            <button className="button is-success" onClick={() => this.filter("Delivery")}>
                                Delivery
                            </button>
                        </div>

                        <div className="search-bar" style={{ display: "flex" }}>
                            <input type="text" className="input" placeholder="Busca por Correo / Nombre" id="search-bar-list"/>
                            <button className="button" onClick={()=> this.filter("SEARCHBAR")}>
                                <span className="icon is-small">
                                    <i className="fas fa-search"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                    <table className="table" id="list-users">
                        <thead>
                            <tr>
                                <th>Imagen</th>
                                <th>Nombre</th>
                                <th>Correo</th>
                                <th>Numero de Telefono</th>
                                <th>Rol</th>
                            </tr>
                        </thead>
                        {this.renderUsers()}
                        <tbody>
                            <tr>
                                <th>Imagen</th>
                                <th>Nombre</th>
                                <th>Correo</th>
                                <th>Numero de Telefono</th>
                                <th>Rol</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Page>
        );
    }
}

export default ListUsers;